export const environmentSecret = {
  encryptionKey: 'Zjk3KOXcE5PGoOA5FmpG67olfRR7QoBeKjczYGe8bB8='
};
